import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, Segment } from 'semantic-ui-react';
import {getToken} from '../adalConfig';
import '../styles/NavMenu.css';

class NavMenu extends Component {

	state = { activeItem: 'home', user:'' }
	handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  saveUser = (u) => {
    this.setState({user: u.login});
  }

  constructor(props) {
    super(props);
    this.fetchUser();
  }

  fetchUser = () => {
    const headers = { Authorization: `Bearer ${getToken()}` };
    fetch('/api/user/current', { headers })
      .then(response => {
        if (response.ok) {
          
          response.json().then(u => {
            this.saveUser(u);
          });
        
        } else {
          
        }
      });
  }

  render() {
	const { activeItem } = this.state

    return (
   <div className="divMenu">
     <div className="divNav">
       <Segment inverted>
        <Menu inverted pointing secondary>
          <Menu.Item
            as={NavLink}
            exact to="/"
            name='Dashboard'
            active={activeItem === 'Dashboard'}
            onClick={this.handleItemClick}
          />
        <Menu.Item
            as={NavLink}
            to="/All"
            name='All Metrics'
            active={activeItem === 'DashboardExtended'}
            onClick={this.handleItemClick}
          />
		    <Menu.Item
            as={NavLink}
            to='/Instances'
			      name='Instances'
			      active={activeItem === 'Instances'}
            onClick={this.handleItemClick}
          />
          <Menu.Item
            as={NavLink}
            to='/Events'
            name='Events'
            active={activeItem === 'Events'}
            onClick={this.handleItemClick}
          />
          <Menu.Item
            as={NavLink}
            to='/Audits'
            name='Audit Log'
            active={activeItem === 'Audits'}
            onClick={this.handleItemClick}
          />
          <Menu.Item
            as={NavLink}
            to="/Settings"
            name='Settings'
            active={activeItem === 'Settings'}
            onClick={this.handleItemClick}
          />
          <Menu.Item
            as={NavLink}
            to="/Help"
            name='Help'
            active={activeItem === 'Help'}
            onClick={this.handleItemClick}
          />
          
        </Menu>
        </Segment>
        </div>
        <div className="divUser">
        <Menu inverted pointing secondary >
        <Menu.Item
            as={NavLink}
            to="/"
            name= {"Welcome " + (this.state.user != null ? this.state.user.split("@")[0] : "!") }
          />
        </Menu>
        </div>
        </div>
    );
  }
}

export default NavMenu;




// WEBPACK FOOTER //
// ./src/components/NavMenu.js